import s0_640 from "../../../assets/images/bathello_showroom-640.webp";
import s0_1280 from "../../../assets/images/bathello_showroom-1280.webp";
import s0_2000 from "../../../assets/images/bathello_showroom-2000.webp";
import s1_640 from "../../../assets/images/bathello_showroom_1-640.webp";
import s1_1280 from "../../../assets/images/bathello_showroom_1-1280.webp";
import s1_2000 from "../../../assets/images/bathello_showroom_1-2000.webp";
import s2_640 from "../../../assets/images/bathello_showroom_2-640.webp";
import s2_1280 from "../../../assets/images/bathello_showroom_2-1280.webp";
import s2_2000 from "../../../assets/images/bathello_showroom_2-2000.webp";
import s3_640 from "../../../assets/images/bathello_showroom_3-640.webp";
import s3_1280 from "../../../assets/images/bathello_showroom_3-1280.webp";
import s3_2000 from "../../../assets/images/bathello_showroom_3-2000.webp";
import s4_640 from "../../../assets/images/bathello_showroom_4-640.webp";
import s4_1280 from "../../../assets/images/bathello_showroom_4-1280.webp";
import s4_2000 from "../../../assets/images/bathello_showroom_4-2000.webp";
import "../../index.scss";
import React from "react";
import { SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import "swiper/css/autoplay";
import SwiperFade from "../../../components/Swiper";
import SlideImage from "../../../components/SlideImage";

// Каждое фото в трёх размерах: браузер сам берёт подходящий под ширину экрана
// (телефон ~640px, планшет/ноутбук ~1280px, большой экран 2000px).
// Качество при этом не падает: файл всегда не меньше, чем нужно экрану.
const SLIDES = [
    { w640: s0_640, w1280: s0_1280, w2000: s0_2000 },
    { w640: s1_640, w1280: s1_1280, w2000: s1_2000 },
    { w640: s2_640, w1280: s2_1280, w2000: s2_2000 },
    { w640: s3_640, w1280: s3_1280, w2000: s3_2000 },
    { w640: s4_640, w1280: s4_1280, w2000: s4_2000 },
];

const BSwiper = () => {
    return (
        <SwiperFade>
            {SLIDES.map((item, i) => (
                <SwiperSlide key={i}>
                    <SlideImage
                        className="swiper_img hide_img"
                        priority={i === 0}
                        src={item.w1280}
                        srcSet={`${item.w640} 640w, ${item.w1280} 1280w, ${item.w2000} 2000w`}
                        sizes="100vw"
                        alt="showRoom img"
                    />
                </SwiperSlide>
            ))}
        </SwiperFade>
    );
};

export default BSwiper;
